import styled from 'styled-components';
import { rem } from 'polished';
import { Tr, Td } from 'oxyrion-ui/lib/Table';
import Segment from 'oxyrion-ui/lib/Segment';

export const FlexBox = styled.div`
  display: flex;
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  align-items: ${({ alignItems }) => alignItems || 'center'};
  flex-wrap: ${({ flexWrap }) => flexWrap || 'no-wrap'};
`;

export const PartWrapper = styled.div`
  width: 100%;
  ${({ theme }) => theme.media.m`
  width: ${props => (props.width ? props.width : 'unset')};
`};
`;

export const ColumnFlexBox = styled(FlexBox)`
  flex-direction: column;
`;

export const SliderWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  ${({ theme }) => theme.media.m`
  width: 100%;
  float: right;
`};
`;

export const FlexBoxStart = styled(FlexBox)`
  justify-content: flex-start;
`;

export const FlexBoxEnd = styled(FlexBox)`
  justify-content: flex-end;
`;

export const FlexItem = styled.div`
  flex ${({ flex }) => flex || '1'};
  width: 100%;
`;

export const RouteLinkWraper = styled.li`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme, fontSize }) => fontSize || theme.fontSize || '14px'};
  list-style: none;
  a {
    text-decoration: none;
    margin: ${({ noMargin }) => (noMargin ? '0' : `${rem(10)}`)};
    padding: 0;
    display: block;
    color: ${({ theme }) => theme.color.primary};
    cursor: pointer;
    white-space: nowrap;
  }
  a:visited {
    color: ${({ theme }) => theme.color.primary};
  }
  a:hover {
    text-decoration: underline;
  }
`;

export const H2 = styled.h2`
  max-width: ${({ theme }) => theme.maxWidth || '1980px'};
  padding: 0;
  margin: 0;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSize || '14px'};
  font-family: ${({ theme }) => theme.fontFamily};
`;

export const H3 = styled.h3`
  max-width: ${({ theme }) => theme.maxWidth || '1980px'};
  padding: 0;
  margin: 0;
  // margin-left: ${rem(5)};
  text-align: left;
  font-size: ${({ theme }) => theme.fontSize || '14px'};
  font-family: ${({ theme }) => theme.fontFamily};
`;

export const SegmentWrapper = styled.div`
  width: 100%;
  // border-bottom: solid ${rem(2)} ${({ theme }) => theme.separatorColor};
  height: auto;
  border-left: ${({ left, theme }) =>
    left ? `solid ${rem(2)}  ${theme.separatorColor}` : 'none'}
  border-right: ${({ right, theme }) =>
    right ? `solid ${rem(2)}  ${theme.separatorColor}` : 'none'}
  margin-bottom: 1px;
`;

export const PageNavigatorWrapper = styled.div`
  margin: ${rem(15)} ${rem(10)};
  font-size: ${({ theme }) => theme.fontSize || '14px'};
`;

export const IconWrapper = styled.img`
  display: ${({ display }) => (display ? 'inline-block' : 'none')};
  margin: ${rem(2)} ${rem(5)};
`;

export const DivIconWrapper = styled.div`
  cursor: pointer;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: ${rem(50)} auto 0;
  min-height: 20vh;
`;

export const DisableAbleTrow = styled(Tr)`
  ${({ disabled, theme }) =>
    disabled ? `color: ${theme.color.disabled}` : ``};
`;

export const ErrorWrapper = styled(FlexBox)`
  width: 80%;
  margin: ${rem(30)} auto;
`;

export const OverflowBox = styled.div`
  overflow: auto;
`;

export const Close = styled.img`
  cursor: pointer;
`;

export const ResponsiveFlexWrapper = styled(FlexBoxStart)`
  width: 100%;
  margin: 0;
  align-items: stretch;
  flex-direction: column;
  ${({ theme }) => theme.media.m`
    flex-direction: row;
  `};
`;

export const FlexInfotableSubWrapper = styled(ColumnFlexBox)`
  width: 100%;
  justify-content: flex-start;
  align-items: stretch;
  border-left: ${({ left, theme }) =>
    left ? `solid ${rem(2)} ${theme.separatorColor}` : 'none'};
  border-right: ${({ right, theme }) =>
    right ? `solid ${rem(2)} ${theme.separatorColor}` : 'none'};
`;

export const AnimatedFormMessageWrapper = styled.div`
  overflow: ${({ display }) => (display ? 'unset' : 'hidden')}
  position: ${({ success }) => success && 'sticky'};
  top: ${({ success }) => success && rem(50)};
  z-index: ${({ success }) => success && '2'};
  max-height: ${({ display }) => (display ? 'unset' : '0px')};  
  opacity: ${({ display }) => (display ? '1' : '0')}
  transition: opacity 0.5s, max-height 1s;
  width: ${({ width }) => width || 'unset'}

`;

export const ClickableTd = styled(Td)`
  cursor: ${({ clickable }) => (clickable ? 'pointer' : '')};
  color: ${({ clickable, theme }) => (clickable ? theme.color.primary : '')};
  &:hover {
    text-decoration: ${({ clickable }) => (clickable ? 'underline' : 'none')};
  }
  &:last-of-type {
    padding-right: ${rem(15)};
  }
`;

export const WidgetFlexBox = styled(FlexBoxStart)`
  align-items: stretch;
  flex-direction: column;
  ${({ theme }) => theme.media.xl`
  flex-direction: row;
`};
`;

export const GraphTableWrapper = styled(FlexBox)`
  flex-direction: column-reverse;
  ${({ theme }) => theme.media.m`
  flex-direction: row;
  justify-content: space-around;
  align-items: stretch;
  width: 90%;
`};
`;

export const DivRouterLinkWrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily};
  font-size: ${({ theme, fontSize }) => fontSize || theme.fontSize || '14px'};
  list-style: none;
  a {
    text-decoration: none;
    margin: ${({ noMargin }) => (noMargin ? '0' : `0 ${rem(10)}`)};
    padding: 0;
    display: block;
    color: ${({ theme, color }) => color || theme.color.primary};
    cursor: pointer;
    white-space: nowrap;
  }
  a:visited {
    color: ${({ theme, color }) => color || theme.color.primary};
  }
  a:hover {
    text-decoration: underline;
  }
`;
export const ControlButtonItem = styled.li`
  text-decoration: none;
  margin: 0 ${rem(10)};
  padding: ${rem(5)} 0;
  display: block;
  color: ${({ theme }) => theme.color.primary};
  cursor: pointer;
  white-space: nowrap;
`;

export const IFrame = styled.iframe`
  border: none;
  outline: none;
  width: 100%;
  height: ${rem(60)};
`;

export const SpaceWrapper = styled.span`
  margin-left: ${({ left, value }) => left && rem(value || 10)}};
  margin-right: ${({ right, value }) => right && rem(value || 10)}};
  margin-top: ${({ top, value }) => top && rem(value || 10)}};
  margin-bottom: ${({ bottom, value }) => bottom && rem(value || 10)}};
`;

export const Bold = styled.span`
  font-weight: ${({ weight }) => weight || 'bold'};
`;

export const PositionContent = styled.div`
  text-align: ${({ at }) => at || 'center'};
`;

export const IconInputWrapper = styled.div`
  position: relative;
`;

export const SpanWidthWrapper = styled.span`
  width: ${({ width }) => width || '100%'};
`;

export const DivWidthWrapper = styled.div`
  width: ${({ width }) => width || '100%'};
`;

export const CustomSegment = styled(Segment)`
  padding: ${({ padding }) => padding};
`;

export const DivMarginWrapper = styled.div`
  margin-right: ${({ right, value }) => right && value};
  margin-left: ${({ left, value }) => left && value};
  margin-top: ${({ top, value }) => top && value};
  margin-bottom: ${({ bottom, value }) => bottom && value};
`;

export const Error = styled.p`
  background-color: ${({ theme }) => theme.color.danger};
`;

export const OrderInfoPanel = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: start;
  border: ${rem(1)} solid #ccc;
  box-shadow: 0 ${rem(2)} ${rem(4.55)} ${rem(0.45)} rgba(1, 1, 1, 0.07);
  margin-bottom: ${rem(20)};
  padding: ${rem(20)};
  background: ${({ theme }) => theme.segment.secondaryBg};
`;

export const ResponsiveTabs = styled.div`
  display: flex;
  flex: 0 1 100%;
  ${({ theme }) => theme.media.m`
flex: 0 1 calc(50% - 20px);
`};
  ${({ theme }) => theme.media.l`
flex: 0 1 calc(33.3% - 20px);
`};
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: ${rem(24)};
  color: #757171;
  font-weight: 300;
`;

export const InfoBox = styled.div`
  font-family: 'Open Sans';
  font-weight: 100;
  border: 1px solid #cfcfcf;
  box-shadow: 1px 2px 0.98px 0.02px rgba(0, 0, 0, 0.09);
  font-size: 14px;
  padding: ${rem(5)} ${rem(20)} ${rem(5)} ${rem(20)};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${rem(20)};
  margin-right: 0;
`;

export const DarSegment = styled(CustomSegment)`
  background: #3e3c3b;
  color: ${({ theme }) => theme.segment.primaryBg};
  display: flex;
  align-items: center;
  margin-top: ${rem(20)};
  margin-bottom: ${rem(20)};
`;



// WEBPACK FOOTER //
// ./src/Components/ReusableComponents/index.js